import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './RatingSegmentItem.scss';

const RatingSegmentItem = ({ className = '', segmentStyle = {}, text }) => {
  return (
    <div className={cx(styles.segmentItemText, className)} style={segmentStyle}>
      {text}
    </div>
  );
};

RatingSegmentItem.propTypes = {
  className: PropTypes.string,
  segmentStyle: PropTypes.object,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RatingSegmentItem;
